<template>
<div v-if="guidelineId != null">
  <b-table striped hover :items="comments" :fields="['user_name', 'created_at', 'comment']">
    <template slot="table-colgroup">
      <col width="20%">
      <col width="20%">
      <col width="60%">
    </template>

    <template slot="user_name" slot-scope="data">
      {{ data.item.author }}
    </template>

    <template slot="comment" slot-scope="data">
      <div class="preLine">{{ data.item.comment }}</div>
    </template>
  </b-table>

  <b-alert show v-show="comments.length < 1">
    {{ $t('message.Comments.noComments') }}
  </b-alert>

  <template v-if="showForm">
    <b-form-textarea
     v-model="comment"
     :placeholder="$t('message.Comments.enterComment')"
     :rows="4"
     :max-rows="6"
     v-validate="'required'"
     data-vv-name="comment"
     data-vv-scope="comments"
     :state="errors.first('comments.comment')?'invalid':null">
    </b-form-textarea>

    <b-button variant="primary" class="float-right mt-2" @click="addComment">
      <template v-if="onHold==false">
        {{ $t('message.submit') }}
      </template>
      <template v-else>
        {{ $t('message.Guideline.sendCommentsToSubmitter') }}
      </template>
    </b-button>
  </template>

  <b-button v-if="showForm==false && !locked && !onHold" variant="outline-secondary" class="float-right mt-2" @click="showForm=true">{{ $t('message.Comments.add') }}</b-button>
</div>
</template>

<script>
import { COMMENT_ADD, COMMENT_REQUEST } from '@/store/actions/comments'

export default {
  name: 'comments',
  components: {},
  props: {
    guidelineId: {
      type: Number,
      required: true
    },
    locked: {
      type: Boolean,
      required: true
    },
    onHold: {
      type: Boolean,
      required: false
    },
  }, 
  data () {
    return {
      comment: null,
      comments: [],
      showForm: false,
    }
  },
  computed: {
  },
  mounted () {
    this.showForm = false
    if (this.onHold == true) {
      this.showForm = true
    }
    this.getComments();
  },
  methods: {
    addComment() {
      this.$validator.validate('comments.*').then(result => {
        if (!result) {
          this.$swal({
            title: 'Error!',
            text: this.$t("message.Comments.fillRequiredFields"),
            type: 'error',
            confirmButtonText: 'OK'
          });

        } else {
          this.$store.dispatch(COMMENT_ADD, { gid: this.guidelineId, comment: this.comment }).then((response) => {
            this.comments.unshift(response.data.data);
            this.comment = null;
            this.$validator.reset({scope: 'comments'});
            this.showForm = false;
          }).catch((error) => {
            this.handleUnauth(error.response.status);
            this.handleForbidden(error.response.status);
          });
        }
      });
    },

    getComments() {
      if (this.guidelineId == null) {
        return;
      }

      this.$store.dispatch(COMMENT_REQUEST, this.guidelineId).then((response) => {
        this.comments = response.data.data;
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },
  },

  watch: {
    guidelineId: function (newQuestion, oldQuestion) {
      if (oldQuestion == null) {
        this.getComments();
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
